import { Tooltip } from 'antd'
import { getDependenciesList } from 'api/Project/dependencies'
import { IconBlocking, IconTasks, IconWaiting } from 'common/SVG/svg.common'
import { getCookie } from 'helper/cookie'

const renderIconDependency = (
  itemTask,
  setIsOpenModalDependencies,
  setDataModalDependencies,
) => {
  const token = getCookie('access_token_admin')
  const getDependenciesListToModal = async (item) => {
    await getDependenciesList(item.project_id, item.id, token).then((res) => {
      const { data, status } = res
      if (status === 200) {
        const dataToModal = {
          ...item,
          ...data,
        }
        setIsOpenModalDependencies(true)
        setDataModalDependencies(dataToModal)
      }
    })
  }

  return (
    <div
      style={{
        display: 'flex',
        marginLeft: '9px',
        marginTop: '-2px',
        height: '16px',
        cursor: 'pointer',
      }}
    >
      {itemTask?.waiting === 'y' && (
        <Tooltip placement='top' title={'Waiting on dependency'}>
          <div
            style={{ marginRight: '8px' }}
            onClick={() => {
              getDependenciesListToModal(itemTask)
            }}
          >
            <IconWaiting width={16} height={16} />
          </div>
        </Tooltip>
      )}

      {itemTask?.blocking === 'y' && itemTask?.waiting !== 'y' && (
        <Tooltip placement='top' title={'Blocking dependency'}>
          <div
            style={{ marginRight: '8px' }}
            onClick={() => {
              getDependenciesListToModal(itemTask)
            }}
          >
            <IconBlocking width={16} height={16} />
          </div>
        </Tooltip>
      )}

      {itemTask?.tasks === 'y' && (
        <Tooltip placement='top' title={'Has relationship links'}>
          <div
            style={{ marginRight: '8px' }}
            onClick={() => {
              getDependenciesListToModal(itemTask)
            }}
          >
            <IconTasks width={16} height={16} />
          </div>
        </Tooltip>
      )}
    </div>
  )
}

export default renderIconDependency
